import { useDispatch } from "react-redux";
import { personByDocumentClearData, personByIdClearData } from "../../../store/person/actions";
var useUI = function (navigate) {
    var dispatch = useDispatch();
    var handleClickSeeDetails = function (data) {
        dispatch(personByDocumentClearData());
        dispatch(personByIdClearData());
        navigate("/client-record/".concat(data.documentId));
    };
    return {
        handleClickSeeDetails: handleClickSeeDetails
    };
};
export default useUI;
